import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

/**
 * Leerzustand (Design 3.0, D4): eine Zeile Haltung + direkte Aktion.
 * Für DataGrid-noRowsOverlay ebenso wie für leere Kacheln/Bereiche.
 *
 *   title   – die eine Zeile („Noch keine Kontakte")
 *   hint    – optionaler Halbsatz darunter
 *   actionLabel/onAction – optionaler Button („Den ersten anlegen")
 */
export default function EmptyState({ title, hint, actionLabel, onAction }) {
  return (
    <Box sx={{
      height: '100%', minHeight: 120, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 0.5, py: 3, px: 2, textAlign: 'center',
    }}>
      <Typography sx={{ fontWeight: 650, color: 'text.primary' }}>{title}</Typography>
      {hint && <Typography variant="body2" color="text.secondary">{hint}</Typography>}
      {actionLabel && onAction && (
        <Button size="small" variant="outlined" onClick={onAction} sx={{ mt: 1 }}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}
